import { type LogLevel } from '@/utils';

export const LOG_LEVEL: LogLevel =
  ENV.ENVIRONMENT === 'production' ? 'warn' : 'log';

export const APP_LAYOUT_HEIGHT = {
  HEADER: 78,
  FOOTER: 76,
  CONTENT_HEADER: 78,
} as const;
